import request from '@/utils/request'

// 列表
export function logList(params) {
  return request({
    url: '/sys/syncLog/list',
    method: 'get',
    params
  })
}